<div class="container">
  <div class="headerContainer">
    <div class="leftPartcontainer">
      @if (showBackToHome) {
        <a [routerLink]="['']">
          <div class="zoom">
            <i class="bi bi-house-fill zoom"></i>
            {{ 'common.navigation.backToHome' | translate }}
          </div>
        </a>
      }
    </div>
    <div class="rightPartContainer">
      <app-language-selector></app-language-selector>
      <a class="headerLink zoom" [routerLink]="['/settings']">
        <img class="headerImgSmall" src="assets/header/settings.png" draggable="false" />
      </a>
    </div>
  </div>
</div>

<!-- Translation Status Component -->
<app-translation-status></app-translation-status>
